// extracted by mini-css-extract-plugin
export var cardContainer = "_od-0";
export var cardHeader = "_od-2";
export var collapsedState = "_od-3";
export var dragHandle = "_od-5";
export var dragHandleIcon = "_od-6";
export var dragging = "_od-1";
export var titleArea = "_od-4";